import { api } from "./api";

/**
 * Gestión de personas.
 *
 * Quién puede ver a quién lo decide el servidor a partir de los permisos:
 * `view_all_users` ve a todo el mundo y `view_clients` solo a los clientes,
 * que impone él mismo aunque se le pida otro filtro.
 */

export const fetchUsersService = (params = {}) => api.get('/admin/users', { params });

export const createUserService = (body) => api.post('/admin/users', body);

export const updateUserRolesService = (userId, roles) =>
    api.put(`/admin/users/${userId}/roles`, { roles });
